
const filterProfilesByVertical = (
  accounts = [],
  targetVerticalId,
  filters = {},
) => {
  const { uam_id, admission_number } = filters;
  const matched = [];

  accounts.forEach((account) => {
    (account.profiles || []).forEach((profile) => {
      const profileVerticalId = profile.verticalId ?? profile.vertical_id;
      const profileUamId = profile.uamId ?? profile.uam_id;
      const profileAdmissionId = profile.admissionId ?? profile.admission_id;

      let isMatch = String(profileVerticalId) === String(targetVerticalId);

      if (isMatch && uam_id && String(profileUamId) !== String(uam_id)) {
        isMatch = false;
      }

      if (
        isMatch &&
        admission_number &&
        String(profileAdmissionId) !== String(admission_number)
      ) {
        isMatch = false;
      }

      if (isMatch) {
        matched.push({ account, profile });
      }
    });
  });

  return matched;
};

export default filterProfilesByVertical;
